import { ShopifyOrder } from '../../features/orders/models/ShopifyOrder';
import { FoxpostShippingInformation } from '../../models/ppoints/FoxpostShippingInformation';
import OrderService from '../../features/orders/services/OrderService';
import { ShippingType } from '../../features/orders/models/ShippingType';
import { FoxpostOrderStatus } from '../../models/ppoints/FoxpostOrderStatus';
import httpApi from '../../hooks/api/httpApi';
import { downloadFileContent } from '../../utils/utils';
import { FoxpostCreateParcelsResponse } from '../../models/ppoints/FoxpostCreateParcelsResponse';
import SettingService from 'features/settings/services/SettingService';
import { SettingKey } from 'data/ppoints/constants';
import ApiKeyService from 'services/settings/ppoints/ApiKeyService';
import { FoxpostApiKeysSetting } from 'models/ppoints/settings/SettingsToEcom';

let store;
const injectStore = (_store) => {
    store = _store;
};

const getShippingInfoForOrders = async (ecomId: number, orderIds: number[]) => {
    let res = await httpApi.post<FoxpostShippingInformation[]>(`/api/ecom/${ecomId}/foxpost/shipping-info`, {
        shopify_order_ids: orderIds,
    });
    let data = res.getData();
    return data;
};

const getShippingInfoForOrder = async (ecomId: number, orderId: number) => {
    let res = await httpApi.post<FoxpostShippingInformation[]>(`/api/ecom/${ecomId}/foxpost/shipping-info`, {
        shopify_order_ids: [orderId],
    });
    let data = res.getData();
    return data[0] || null;
};

const isApiKeyValid = async (ecomId: number): Promise<boolean> => {
    const apiTestMode: boolean = store.getState().settings.settings[SettingKey.use_test_api_foxpost];
    let apiKeys: FoxpostApiKeysSetting | null = null;
    if (apiTestMode) {
        apiKeys = store.getState().settings.settings[SettingKey.test_api_keys_foxpost];
    } else {
        apiKeys = store.getState().settings.settings[SettingKey.foxpost_api_keys];
    }
    return (
        (await ApiKeyService.validateFoxpost(
            ecomId,
            apiTestMode,
            apiKeys?.username || '',
            apiKeys?.password || '',
            apiKeys?.api_key || ''
        )) === true
    );
};
const checkApiKeysWithErrorToast = async (ecomId: number) => {
    if (!(await isApiKeyValid(ecomId))) {
        // TODO: add banner!!!!
        // toastUtils.error('Foxpost Api Keys are invalid!');
        throw new Error('Foxpost Api Keys are invalid!');
    }
};

const createParcels = async (ecomId: number, orderIds: number[]) => {
    await checkApiKeysWithErrorToast(ecomId);
    const senderDetailsSetting = store.getState().settings.settings[SettingKey.sender_details];
    await SettingService.checkSenderDetailsValidityWithErrorToast(senderDetailsSetting);

    let res = await httpApi.post<FoxpostCreateParcelsResponse>(`/api/ecom/${ecomId}/foxpost/create-parcels`, {
        shopify_order_ids: orderIds,
    });
    let data = res.getData();
    return data;
};

const downloadLabelsPdfForOrderIds = async (ecomId: number, orderIds: number[]) => {
    let res = await httpApi.post<string>(`/api/ecom/${ecomId}/foxpost/labels`, {
        shopify_order_ids: orderIds,
    });
    let data = res.getData();
    downloadFileContent(data, `foxpost-labels.pdf`);
};

const downloadDeliveryNotePdfForOrderIds = async (ecomId: number, orderIds: number[]) => {
    let res = await httpApi.post<string>(`/api/ecom/${ecomId}/foxpost/delivery-note`, {
        shopify_order_ids: orderIds,
    });
    let data = res.getData();
    downloadFileContent(data, `foxpost-delivery-note.pdf`);
};

const getStatus = (
    ecomId: number,
    order: ShopifyOrder,
    foxpostShippingInfo: FoxpostShippingInformation
): FoxpostOrderStatus | null => {
    let shippingType = OrderService.getShippingType(order);
    if (shippingType !== ShippingType.FOXPOST) {
        return null;
    }

    if (!foxpostShippingInfo) {
        return FoxpostOrderStatus.SHIPMENT_AWAITING;
    }
    return foxpostShippingInfo.status;
};

export default {
    injectStore,
    getShippingInfoForOrders,
    getShippingInfoForOrder,
    createParcels,
    getStatus,
    downloadLabelsPdfForOrderIds,
    downloadDeliveryNotePdfForOrderIds,
    checkApiKeysWithErrorToast,
};
